import Landbot, { LandbotContext } from "src/components/Bots/Landbot";

import Analytics from "src/lib/analytics/analytics";
import Button from "@material-ui/core/Button";
import MainLayout from "src/components/Layout/MainLayout";
import React from "react";
import SeoHead from "src/components/Seo/SeoHead";
import { TheCycleverseTheme } from "src/theme";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(6),
    textAlign: "center",
  },
  headline1: {
    ...theme.headline2,
    fontWeight: 300,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      fontSize: 20,
    },
  },
  headline2: {
    fontSize: 36,
    marginTop: 0,
    marginBottom: theme.spacing(8),
    fontFamily: theme.highlightFontFamily,
    fontWeight: 900,
    maxWidth: 900,
    display: "inline-block",
    lineHeight: "1.1",
  },
  content: {
    textAlign: "left",
    maxWidth: 800,
    display: "inline-block",
    fontSize: "medium",
    "& b,strong": {
      fontWeight: 900,
    },
    "& h2": {
      ...theme.headline2,
      fontWeight: 300,
      marginTop: theme.spacing(4),
      [theme.breakpoints.down("xs")]: {
        fontSize: 20,
      },
    },
    "& table": {
      borderCollapse: "collapse",
      width: "100%",
      backgroundColor: theme.tableBodyBgColor,
      border: "1px solid",
    },
    "& th": {
      border: "1px solid",
      padding: 5,
      fontSize: 15,
      backgroundColor: theme.tableHeaderBgColor,
      borderColor: theme.tableHeaderBorderColor,
      color: theme.tableHeaderFgColor,
      textAlign: "center",
    },
    "& td": {
      border: `1px solid ${theme.tableHeaderBgColor}`,
      padding: 5,
      textAlign: "center",
    },
  },
  landbot: {
    width: "100%",
    height: 500,
    "& .LandbotFrame": {
      height: 500,
    },
  },
  startButton: {
    color: theme.palette.background.secondary,
    backgroundColor: theme.openButtonColor,
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(4),
    padding: "8px 16px",
    fontSize: 18,
  },
  separator: {
    height: 1,
    // NOTE: this is the fallback for old browsers if the next one
    // doesn't make sense to them
    background: theme.highlightGradientBg,
    // eslint-disable-next-line no-dupe-keys
    // @ts-ignore
    background: theme.highlightGradient,
  },
  intro: {
    margin: theme.spacing(2),
  },
}));

const Content = () => {
  const { t } = useTranslation("woomBikeGroesse");
  const classes = useStyles();
  const landbotContext = React.useContext(LandbotContext);

  const launchBot = React.useCallback(() => {
    landbotContext.launchBot();
  }, [landbotContext]);

  return (
    <div className={classes.root} data-test="page-woom-bike-groesse">
      <h1 className={classes.headline1}>{t("headline1")}</h1>
      <h2 className={classes.headline2}>{t("headline2")}</h2>

      <div className={clsx(classes.content, classes.intro)}>
        <p>
          {t("intro1-1")}
          <a href="https://thecycleverse.com/de/marken/Woom" target="_blank" rel="noreferrer">
            {t("intro1-2")}
          </a>
          {t("intro1-3")}
        </p>
        <p>{t("intro2")}</p>
        <p>{t("intro3")}</p>
      </div>

      <div>
        <img loading="lazy" src="https://images.thecycleverse.com/clara.svg" width={60} height={55} alt="clara" />
      </div>

      <div>
        <Button
          className={classes.startButton}
          onClick={() => {
            launchBot();
          }}
        >
          {t("startButton")}
        </Button>
      </div>

      <div className={classes.separator} />

      <div className={classes.content}>
        <h2>{t("sec1Text1")}</h2>
        <p>{t("sec1Text2")}</p>
        <p>{t("sec1Text3")}</p>
      </div>

      <div>
        <Button
          className={classes.startButton}
          onClick={() => {
            launchBot();
          }}
        >
          {t("startButton")}
        </Button>
      </div>
    </div>
  );
};

const Page = () => {
  const { t } = useTranslation("woomBikeGroesse");

  return (
    <MainLayout>
      <SeoHead
        title={t("pageTitle")}
        description={t("pageDescription")}
        ogImage="/images/bots/woom-Finder-OpenGraph.png"
        ogDescription={t("ogDescription")}
      >
        <script async src="https://static.landbot.io/landbot-3/landbot-3.0.0.js"></script>
      </SeoHead>

      <Landbot
        landbotUrl="https://storage.googleapis.com/landbot.pro/v3/H-1477771-ZDWZH1JSM9O39ORT/index.json"
        onLaunchBot={() => {
          Analytics.botStart("woomBikeGroesse");
        }}
      >
        <Content />
      </Landbot>
    </MainLayout>
  );
};

export default Page;
